<template>
<div>
    <b-form-select v-model="selected" @change="onChange" :options="tax_rates">
    </b-form-select>
</div>
</template>
<script>
import TaxRateService from "@/store/services/taxrate.service.js";

export default {
    name: "VatInput",
    props: ['value', 'countryCode'],
    components: {},
    data() {
        return {
            tax_rates: [],
            item: this.$props.value,
            selected: this.$props.value.vat_exempt ? 'exempt' : this.$props.value.tax_rate,
        }
    },
    created(){
        var vm = this;
        TaxRateService.list({'country': this.$props.countryCode || 'NL'}).then(function (response) {
            vm.tax_rates = response.data;
            vm.tax_rates = vm.tax_rates.sort(vm._compare);
            for(var i=0;i<vm.tax_rates.length;i++){
                vm.tax_rates[i].text = vm.tax_rates[i].taxrate+"%";
                vm.tax_rates[i].value = vm.tax_rates[i].taxrate;
            }
            vm.tax_rates.push({value: 'exempt', text: vm.$gettext("VAT exempt"), order: -1});
        });
    },
    methods: {
        onChange (value){
            if(value == 'exempt'){
                this.item.vat_exempt = true;
            }else{
                this.item.vat_exempt = false;
                this.item.tax_rate = value;
            }
            this.$emit('input', this.item);
        },
        _compare(a, b) {
            const groupA = a.taxrate;
            const groupB = b.taxrate;
            if (groupA > groupB) {
                return -1;
            } else if (groupA < groupB) {
                return 1;
            }
        },
    }
};
</script>
<style >
</style>